import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { SectionContext } from "../../context/sectionContext"
// import { insWords, applyComma, wordCapital } from "../../../shared/functions"
import { JourneyContext } from "../../context/journeyContext"
import { getValueFromJourney, isEquitasChannel ,getValueFromLookup} from "../../services/helperFunctions"
import { insWords, applyComma, wordCapital, lineCapital } from "../../../shared/functions"
import { ErrorContext } from "../../context/errorContext"
import * as lookup from "../../../../static/lookup.json"
import { isIE } from 'react-device-detect';
import { ifscCodeDetails } from "../../../services/apiservice"

const InputContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > .str-input {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  & input {
    border: none;
    outline: none;
    margin: 0;
    padding: 0;
    line-height: 4;
    height: 42px;
    background: ${props => props.channel === "A" ? "#ededed" :  "#fff"};
    background: var(--lumiq-bg);
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 2px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" ? "#ededed" :  "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    /* z-index: 999; */
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
  }
`
const numToWordFormControlKey = ["AnnualIncome", "sumAssured"]

export default function RepeatableComponentTextString(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [errorState, setErrorState, fieldRefs, scrollToFirstError, scrollFieldToTop] = useContext(ErrorContext)
  const [ journeyState, setJourneyState] = useContext(JourneyContext)
  const [showLocalError, setShowLocalError] = useState(false)

  const validate = target => {
    let temp
    let temp1
    if (errorState[props.data.formControlKey]) {
      temp1 = errorState[props.data.formControlKey]
    }else{
      temp1 = []
    }
    if (props.data.required) {
    //   required field validation
      if(!sectionState.sectionData[props.data.formControlKey] || !sectionState.sectionData[props.data.formControlKey][props.index]){
        // console.log("dchdh1", props, sectionState)

        temp1[props.index] = `Please Enter ${lineCapital(getValueFromLookup(
          "label",
          props.data.label
        )) || props.data.label}`
        
        temp = temp1
        setErrorState( prev => {
            return ({
            ...prev,
            [props.data.formControlKey]: temp
            })
        })
        return 
      }
      if((sectionState.sectionData[props.data.formControlKey]) && (!sectionState.sectionData[props.data.formControlKey][props.index])){
        // temp1[props.index] = `Please Enter ${props.data.label}`
        temp1[props.index] =`Please Enter ${lineCapital(getValueFromLookup(
          "label",
          props.data.label
        )) || props.data.label}`
        
        temp = temp1
        setErrorState( prev => {
          // console.log("dchdh2", props, sectionState)
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      }else{
        temp1[props.index] = ""
        temp = temp1
        setErrorState(prev => {
          // console.log("dchdh3", props, sectionState)
          return({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      }
      temp1[props.index] = ""
      temp = temp1
      if(target.value){
        // console.log("dchdh4", props, sectionState)
        setErrorState(prev => {
          return({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      }
    }
    if (target.value) {
      if (props.data.min_len) {
        // min_len validation
        if (target.value.length < props.data.min_len) {
          temp1[props.index] = `Minimum length should be ${props.data.min_len}`
          // temp1[props.index] = lineCapital(getValueFromJourney(
          //   journeyState.lookup.min_error,
          //   props.data.min_len_error
          // ))
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: temp,
            }
          })
          setShowLocalError(true)
          return
        } else {
          temp1[props.index] = ""
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: temp,
            }
          })
        }
      }
      if (props.data.max_length) {
        //max length validation
        if (target.value.length > props.data.max_length) {
          temp1[props.index] = `Maximum length required is ${props.data.max_length}`
          // temp1[props.index] =  lineCapital(getValueFromJourney(
          //   journeyState.lookup.max_error,
          //   props.data.max_len_error
          // ))
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: temp,
            }
          })
          setShowLocalError(true)
          return
        } else {
          temp1[props.index] = ""
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: temp
            }
          })
        }
      }
      if(target.value){
        let pattern = /[\<\>\[\{\]\}\^\?\(\)]/
        let n = pattern.test(target.value.toString())
        //no vapt since below two field are disabled
        if(n && !(props.data.formControlKey === "bankBranchName" || props.data.formControlKey === "bankName")){
          temp1[props.index] = `Please enter valid ${lineCapital(getValueFromLookup(
            "label",
            props.data.label
          )) || props.data.label}`
        temp=temp1
        setErrorState(prev => {
          return {
            ...prev,
            [props.data
              .formControlKey]: temp,
          }
        })
        setShowLocalError(true)
        return
        }
      }
      if (props.data.regex) {
        let regex = props.data.regex.toString()
        let rg = regex.substring(1, regex.lastIndexOf("/"))
        let flags = regex.substring(regex.lastIndexOf("/") + 1)
        let regex_exp = new RegExp(rg, flags)
        if (regex_exp.test(target.value)) {
          temp1[props.index] = ""
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: temp,
            }
          })
        } else {
          temp1[props.index] = `Please enter valid  ${lineCapital(getValueFromLookup(
            "label",
            props.data.label
          )) || props.data.label}`
          // temp1[props.index] = lineCapital(getValueFromJourney(
          //   journeyState.lookup.required_error,
          //   props.data.regexError
          // ))
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              [props.data
                .formControlKey]: temp,
            }
          })
          setShowLocalError(true)
          return
        }
      }

      if(target.value){
        let pattern = /[\<\>\[\{\]\}\^\?\(\)]/
        let n = pattern.test(target.value.toString())
        if(n  && !(props.data.formControlKey === "bankBranchName" || props.data.formControlKey === "bankName")){
          temp1[props.index] = `Please enter valid  ${lineCapital(getValueFromLookup(
            "label",
            props.data.label
          )) || props.data.label}`
        temp=temp1
        setErrorState(prev => {
          return {
            ...prev,
            [props.data
              .formControlKey]: temp,
          }
        })
        setShowLocalError(true)
        return
        }
      }
    }
    // console.log(errorState, "error State")
    return
  }

  useEffect(() => {
    validate({
      value: (sectionState.sectionData[props.data.formControlKey]? sectionState.sectionData[props.data.formControlKey][props.index] ?? "" : "")
    })
  }, [sectionState.sectionData[props.data.formControlKey]?.[props.index]])

   const checkForIfscCodes = (target) => {
    if (props.data.formControlKey.toLowerCase().includes("ifsccode") && (target.value && target.value.length === 11)) {
      let payload = {
        "MIR-BNK-IFSC-CD": target.value
      }
      ifscCodeDetails(payload)
        .then(res => {
          console.log(res.data)
          if(res?.data?.allUniqueBankName){
            let bankNameList = res?.data?.allUniqueBankName
            let bankName = []
            bankName.push(bankNameList)
            let bankBranchNameList = res?.data?.bankAddress[Object.keys(bankNameList)[0]]
            let temp = journeyState.journeySteps
            let tempPageIndexToChange
            let tempSectionIndexToChange
            let tempComponentGroupIndexToChange
            let tempComponentIndexToChange
            tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
            tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "nomineeDetailsSection")
            tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "nomineePersonalDetail")
            tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "bankName")
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = bankName
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp
              })
            })
            if(Object.keys(bankNameList)?.length === 1){
              let bank = Object.keys(bankNameList)[0]
              let bankBranchName =  Object.keys(bankBranchNameList)[0]

              let temp1 = sectionState.sectionData["bankName"] || []
              let temp2 = sectionState.sectionData["bankBranchName"] || []
              if (!Array.isArray(temp1)){
                temp1 = [...temp1]
              }
              if (!Array.isArray(temp2)){
                temp2 = [...temp2]
              }
              temp1[props.index] = bank
              temp2[props.index] = bankBranchName
              setSectionState(prev => {
                return ({
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    bankName: temp1,
                    bankBranchName: temp2
                  }
                })
              })
            }
          }
          else{
            let bankName = lookup["bankName"]
            let temp = journeyState.journeySteps
            let tempPageIndexToChange
            let tempSectionIndexToChange
            let tempComponentGroupIndexToChange
            let tempComponentIndexToChange
            tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
            tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "nomineeDetailsSection")
            tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "nomineePersonalDetail")
            tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "bankName")
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = bankName
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
      
            tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "nomineePersonalDetail")
            tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "bankBranchName")
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = bankName
            temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true


            let temp1 = sectionState.sectionData["bankName"] || []
            let temp2 = sectionState.sectionData["bankBranchName"] || []
            temp1[props.index] = ""
            temp2[props.index] = ""

            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  bankName: temp1,
                  bankBranchName: temp2
                }
              })
            })
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp
              })
            })
          }
        })
        .catch((err) => {
          console.log("please enter valid ifsc code", err);
        })
    }
  }

  const handleChange = ({ target }) => {
    if (numToWordFormControlKey.includes(props.data.formControlKey) || props.data.formControlKey.toLowerCase().includes("sumassured") ) {
      let regex = new RegExp(/^\d+$/)
      if (regex.test(target.value.replace(/,/g, ""))) {
        let temp = target.value.split(",")
        target.value = temp.join("")
      // target.value = target.value.replaceAll(",", "")
      }else if(target.value ==""){
        target.value =""
      }
      else {
        return  
      }
    }


    if (sectionState.sectionId === props.sectionId) {
      let temp
      if (sectionState.sectionData[props.data.formControlKey]) {
        let temp1 = sectionState.sectionData[props.data.formControlKey]
        if (props.data.formControlKey === "ifscCode"){
          temp1[props.index] = target.value?.toUpperCase() ?? ""
        }else{
          temp1[props.index] = wordCapital(target.value ?? '');
        }
        temp = temp1
      }else{
        let temp1 = []
        temp1[props.index] = wordCapital(target.value ?? '')
        temp = temp1
      }
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: temp,
          },
        }
      })
    } else {
      let temp
      if (sectionState.sectionData[props.data.formControlKey]) {
        let temp1 = sectionState.sectionData[props.data.formControlKey]
        temp1[props.index] = wordCapital(target.value ?? '');
        temp = temp1
      }else{
        let temp1 = []
        temp1[props.index] = wordCapital(target.value ?? '')
        temp = temp1
      }
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: temp,
          },
        }
      })
    }
    validate(target)
    console.log(sectionState, "section state")
  }

  return (
    <>
      <InputContainer ref={el => { if (el && props.data?.formControlKey) fieldRefs.current[`${props.data.formControlKey}_${props.index}`] = el }} channel={props.channel} className={`form-group input-container ${props.data.disabled?'disable-input':''}`} key={props.data.formControlKey + props.index}>
        <label
          className={`input-label ${props.data.label?'':"no-label"} `}
          htmlFor={props.data.id ? props.data.id : props.data.label}
        >
          {/* {props.data.label} */}
          {lineCapital(getValueFromLookup(
          "label",
          props.data.label
        )) || props.data.label}
        {isEquitasChannel(props.channel) && props.data.required && <span className="equitas-required-marker"> *</span>}
        </label>
        <div className="form-control str-input">
          <input
            type="text"
            style={{
              width: numToWordFormControlKey.includes(props.data.formControlKey) || props.data.formControlKey.toLowerCase().includes("sumassured")
                ? "40%"
                : "100%",
            }}
            className={(isIE ? 'IELineHeight' : '')}
            name={props.data.name}
            autoComplete="new-password"
            required={props.data.required}
            // placeholder={props.data.placeholder}
            placeholder={lineCapital(getValueFromLookup(
              "placeholder",
              props.data.placeholder
            )) || props.data.placeholder}

            disabled={props.data.disabled}
            id={props.data.id ? props.data.id + props.index : props.data.label + props.index}
            onChange={handleChange}
            onFocus={() => scrollFieldToTop(`${props.data.formControlKey}_${props.index}`)}
            value={
              (sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey][props.index])
                ? numToWordFormControlKey.includes(props.data.formControlKey) || props.data.formControlKey.toLowerCase().includes("sumassured")
                  ? applyComma(
                      sectionState.sectionData[props.data.formControlKey][props.index]
                    )
                  : sectionState.sectionData[props.data.formControlKey][props.index]
                : ""
            }
            onBlur={e => {
              validate(e.target)
              if (props.data.formControlKey === "ifscCode") {
                checkForIfscCodes(e.target)
              }
            }}
          />
          <span
            style={{
              fontSize: "10px"
            }}
          >
            {numToWordFormControlKey.includes(props.data.formControlKey) || props.data.formControlKey.toLowerCase().includes("sumassured")
              ? insWords(sectionState.sectionData[props.data.formControlKey] ?sectionState.sectionData[props.data.formControlKey][props.index] : '')
              : null}
          </span>
        </div>
        <span className="input-error">
          {(props.showError || showLocalError) && (
            Array.isArray(errorState?.[props.data.formControlKey])
            ? errorState?.[props.data.formControlKey]?.[props.index]
            : errorState?.[props.data.formControlKey]
          )
          }
        </span>
      </InputContainer>
    </>
  )
}
